import React from "react";
// import Button from "../Button";
import heroBg from "../../assets/images/hero.svg";
import leaves from "../../assets/images/leave.svg";
import Button from "../ui/Button";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <section
      className="relative h-screen bg-cover bg-center flex items-center justify-center text-white"
      style={{ backgroundImage: `url(${heroBg})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-[#038e3d]/70"></div>

      {/* Leaves Decoration */}
      <img
        src={leaves}
        alt="leaves"
        className="absolute left-0 bottom-0 w-40 md:w-60 z-10"
      />

      {/* Content */}
      <div className="relative z-20 text-center max-w-3xl px-4">
        <div className="mb-4">
          <span className="bg-blue-600 text-white px-4 py-1 text-sm rounded-md font-[15px] font-semibold">
            Connecting Agriculture Communities
          </span>
        </div>

        <h1 className="text-4xl md:text-6xl font-bold leading-tight mb-6">
          Your One-Stop <span className="text-[#FBBC05]">Agro Marketplace</span>
        </h1>

        <p className="text-base md:text-lg text-white font-semibold mb-8">
          Connecting farmers, buyers & transporters with secure payments,
          verified users, and accessible offline support across all 774 LGAs in
          Nigeria.
        </p>

        <div className="flex gap-40 justify-center">
          <Link to="/signup">
            <Button className="px-6 border border-white">Get Started</Button>
          </Link>
          <Link to="/signup">
            {" "}
            <Button className="px-6 !bg-white !text-black">Watch Demo</Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
